import React, { useEffect, useRef, useState } from "react";
import { Form, Card, Button, Offcanvas } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { IconClose } from "../../../assets/icons";
function SearchModal({ showSearchModal, setShowSearchModal }) {
  const inputRef = useRef(null);
  useEffect(() => {
    if (showSearchModal) {
      inputRef.current?.focus();
      const timer = setTimeout(() => {
        inputRef.current?.focus();
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [showSearchModal]);

  const handleClose = () => {
    setShowSearchModal(false);
  };
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();
  const handleSearch = (e) => {
    e.preventDefault();
    navigate("/search", { state: { searchText: searchText } });
    setShowSearchModal(false);
  };

  return (
    <Offcanvas
      placement="end"
      id="advancedMenu"
      show={showSearchModal}
      onHide={handleClose}
    >
      <Offcanvas.Header className=" border-bottom">
        <Offcanvas.Title className=" d-flex justify-content-between w-100">
          جستجو
          <div onClick={handleClose}>
            <IconClose fillColor="#000" />
          </div>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="bg-light">
        <Form onSubmit={handleSearch}>
          <Card className="rounded-3">
            <Card.Body>
              <Form.Label className="fs-normal  mb-3">
                عبارت مورد نظر را وارد کنید{" "}
              </Form.Label>
              <Form.Control
                type="text"
                // placeholder="جستجو ..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                ref={inputRef}
              ></Form.Control>
            </Card.Body>
          </Card>

          {/* کد‌های کارت‌های دیگر اینجا قرار می‌گیرند */}

          <Button type="submit" className="btn btn-success mt-3 w-100">
            جستجو{" "}
          </Button>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
}
export default SearchModal;
